import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'player-track-prev', 'PlayerTrackPrev', [["path",{"d":"M21 5v14l-8 -7l8 -7"}],["path",{"d":"M10 5v14l-8 -7l8 -7"}]]);